import React from 'react';
import { Select } from 'antd';
import { Form } from '@ant-design/compatible';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { getClassNames } from '../../_utils/classnames';
import { NotificationDeliveryType } from '../../enums/notification-delivery-type';
import { NotificationDeliveryWindow } from '../../enums/notification-delivery-window';
import titleCase from 'title-case';

interface IDeliveryDisplayProps {
    defaults?: {
        type?: string,
        window?: string,
    },
    entity: {
        displayMeta?: {
            default_delivery_type?: string,
            default_delivery_window?: string,
        },
    }
}

export class DomainDeliveryDisplay extends React.PureComponent<IDeliveryDisplayProps, any> {
    public render() {
        const defaultDeliveryType = this.props.defaults?.type || NotificationDeliveryType.IMMEDIATE;
        const defaultDeliveryWindow = this.props.defaults?.window || NotificationDeliveryWindow.STANDARD;

        return (
            <>
                <div className={getClassNames('form-layout-row')}>
                    <div className={getClassNames('form-layout-row-label')}>
                        Delivery Type
                    </div>
                    <div className={getClassNames('form-layout-row-value')}>
                        {titleCase(defaultDeliveryType)}
                    </div>
                </div>

                <div className={getClassNames('form-layout-row')}>
                    <div className={getClassNames('form-layout-row-label')}>
                        Delivery Strategy
                    </div>
                    <div className={getClassNames('form-layout-row-value')}>
                        {defaultDeliveryWindow === NotificationDeliveryWindow.STANDARD ?
                            defaultDeliveryType === NotificationDeliveryType.IMMEDIATE ?
                                'Now' : 'Fixed' : titleCase(this.normalizeForDisplay(defaultDeliveryWindow))}
                    </div>
                </div>
            </>
        );
    }

    private normalizeForDisplay = (value: string): string => {
        let displayString = value;
        if (this.props.entity.displayMeta?.default_delivery_type === NotificationDeliveryType.IMMEDIATE
            && displayString === NotificationDeliveryWindow.STANDARD) {
            displayString = 'NOW';
        }
        if (this.props.entity.displayMeta?.default_delivery_type === NotificationDeliveryType.SCHEDULED) {
            if (displayString === NotificationDeliveryWindow.TIMEZONE) {
                displayString = 'SUBSCRIBER TIME ZONE';
            }
            if (displayString === NotificationDeliveryWindow.STANDARD) {
                displayString = 'FIXED';
            }
        }

        return displayString;
    }
}

interface IDeliveryEditorProps extends FormComponentProps {
    entity: {
        displayMeta?: {
            default_delivery_type?: string,
            default_delivery_window?: string,
        },
    }
}

export class DomainDeliveryEditor extends React.PureComponent<IDeliveryEditorProps, any> {
    public render () {
        const defaultDeliveryType = this.props.entity.displayMeta?.default_delivery_type || NotificationDeliveryType.IMMEDIATE;
        const defaultDeliveryWindow = this.props.entity.displayMeta?.default_delivery_window || NotificationDeliveryWindow.STANDARD;

        return (
            <>
                <Form.Item
                    className={getClassNames('ddf-delivery-editor')}
                    label="Delivery Type"
                >
                    {this.props.form.getFieldDecorator('defaultDeliveryTypeValue', {
                        initialValue: defaultDeliveryType,
                    })(
                        <Select<NotificationDeliveryType>
                            onChange={(type) => { this.props.form.setFieldsValue({ defaultDeliveryWindowValue: undefined }); }}
                        >
                            <Select.Option value={NotificationDeliveryType.IMMEDIATE}>{titleCase(NotificationDeliveryType.IMMEDIATE)}</Select.Option>
                            <Select.Option value={NotificationDeliveryType.SCHEDULED}>{titleCase(NotificationDeliveryType.SCHEDULED)}</Select.Option>
                        </Select>
                    )}
                </Form.Item>

                <Form.Item
                    className={getClassNames('ddf-delivery-editor')}
                    label="Delivery Strategy"
                >
                    {this.props.form.getFieldDecorator('defaultDeliveryWindowValue', {
                        initialValue: defaultDeliveryWindow,
                        rules: [
                            {
                                required: true,
                                message: 'A default delivery strategy is required.'
                            }
                        ]
                    })(
                        <Select>
                            {this.configDefaultStrategyOptions().map(opt => {
                                return <Select.Option key={opt} value={opt}>{titleCase(this.normalizeForDisplay(opt))}</Select.Option>
                            })
                            }
                        </Select>
                    )}
                </Form.Item>
            </>
        )
    }

    private configDefaultStrategyOptions = (): string[] => {
        const fields = this.props.form.getFieldsValue();
        let configOptions: string[] = [];

        if (fields.defaultDeliveryTypeValue === NotificationDeliveryType.IMMEDIATE) {
            configOptions = [
                NotificationDeliveryWindow.STANDARD,
                NotificationDeliveryWindow.INFORMED,
            ];
        }

        if (fields.defaultDeliveryTypeValue === NotificationDeliveryType.SCHEDULED) {
            configOptions = [
                NotificationDeliveryWindow.STANDARD,
                NotificationDeliveryWindow.TIMEZONE,
                NotificationDeliveryWindow.INFORMED,
            ];
        }

        return configOptions;
    }

    private normalizeForDisplay = (value: string): string => {
        let displayString = value;

        if (this.props.form.getFieldValue('defaultDeliveryTypeValue') === NotificationDeliveryType.IMMEDIATE
            && displayString === NotificationDeliveryWindow.STANDARD) {
            displayString = 'NOW';
        }

        if (this.props.form.getFieldValue('defaultDeliveryTypeValue') === NotificationDeliveryType.SCHEDULED) {
            if (displayString === NotificationDeliveryWindow.TIMEZONE) {
                displayString = 'SUBSCRIBER TIME ZONE';
            }
            if (displayString === NotificationDeliveryWindow.STANDARD) {
                displayString = 'FIXED';
            }
        }

        return displayString;
    }
}
